import styled from 'styled-components';
import MUISkeleton from '@material-ui/lab/Skeleton';

export const Skeleton = styled(MUISkeleton)`
  ${({ theme: { breakpoints } }) => `
		width: 100%;
		height: 48px;

		${breakpoints.up('md')} {
			width: 25%;
		}
	`}
`;
